module.exports = __webpack_public_path__ + "img/mattoni_talents_cena.b201cb5c.jpg";